import React from "react";
import { Grid } from "@material-ui/core";
import { useMenuHeaderStyles } from "components/menuHeader/styles";
import NotificationsButton from "components/notifications/notificationsButton";

const MenuHeader: React.FC = (): JSX.Element => {
    const classes = useMenuHeaderStyles();

    return (
        <Grid container wrap="nowrap" alignItems="center" className={classes.root}>
            <Grid item xs={12} className={classes.search} />
            <Grid item className={classes.notifyIconContainer}>
                <NotificationsButton />
            </Grid>
        </Grid>
    );
};

export default MenuHeader;
